import domready from 'domready';

domready(function () {
  var $numberInputs = document.querySelectorAll(".booking-form__field--pax-date-of-birth input[type=\"number\"]");
  if (!$numberInputs) {
    return;
  }
  Array.prototype.forEach.call($numberInputs, function (input) {
    input.addEventListener("change", function (event) {
      var value = input.value;
      event.preventDefault();
      input.value = value.length === 1 && value < 10 ? "0" + value : value;
    });
  });
});
